






























import Vue from "vue";
import { mapGetters } from "vuex";

// Vue components
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";

// Model
import moment from "moment";

export default Vue.extend({
    components: { GlobalStatusInstallationChip },
    data() {
        return {
            moment,
            headers: [
                { value: "installationName", text: this.$t("common.installationName") },
                { value: "status", text: this.$t("common.status") },
                { value: "timestamp", text: "" + this.$t("common.eventTimestamp") + " " + this.$t("common.1_apex") },
                { value: "receivedAt", text: "" + this.$t("common.statusChanged") + " " + this.$t("common.2_apex") },
                { value: "installationLastMessage", text: this.$t("common.lastMessageReceived") },
                { value: "installationAgentIP", text: this.$t("device_status.agent_remote_ip") },
                { value: "machinesSerialNumber", text: this.$t("common.machines") },
            ],
        };
    },
    props: ["installationsStatusHistory"],
    computed: {
        ...mapGetters(["longDateFormat"]),
        legendText() {
            return `${this.$t("common.1_apex")} ${this.$t("dashboard.inst_status_changes_timestamp_explanation")} ${this.$t("common.2_apex")} ${this.$t(
                "dashboard.inst_status_changes_received_at_explanation"
            )}`;
        },
    },
    methods: {
        getFormattedDate(date: Date) {
            return this.moment(date).format(this.longDateFormat(true, false, false, true, true));
        },
    },
});
